import axios from "../axios/axios";
import { setPersons } from "../store/actions/personAction";
import { selectTableItems } from "../store/actions/index";
import { apiSetAlert } from "./appApi";
import { appCloseModal, appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { resetForm, setAction, setEditItem, setIndex, updateFormStatus } from "../store/actions/formAction";
import { setFormData } from "../helpers/FormDataCreator";
import { setTableData } from "../store/actions/dataTableAction";
import { errorDispatcher, getOptionsQuery, setSelectItemLabels } from "../helpers";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetPersonsExcel = (token, personType, selectedIds) => (dispatch, getState) => {
  let url = `persons/excel/export?personType=${personType}`;
  if (selectedIds && selectedIds.length > 0) {
    url += `&ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_")
      const fileName = personType ? `${personType}s_${now}` : `persons_${now}`;
      fileDownload(response.data, `${fileName}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetPerson = (personId, token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`persons/${personId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const data = response.data.data;
      if (data.others.saleCommission || data.others.saleReturnCommission) {
        data.others.haveCommission = true;
      }
      const editItem = { ...data.main, ...data.others };
      dispatch(setEditItem(editItem));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetPersonSettings =
  ({ personId, token }, cb) =>
  (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
      .get(`persons/settings/${personId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        cb && cb(response.data);
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiGetPersons =
  ({ pagination, token, key, sort, search }) =>
  (dispatch, getState) => {
    let personType = key;
    let url = "/persons/list";
    let options = getOptionsQuery(pagination, search, sort);

    if (personType) {
      options.personType = typeof personType === "string" ? personType : "customer";
    }

    dispatch(appSetLoading());
    axios
      .post(url, options, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination && !pagination?.notTable) {
          dispatch(setTableData(response.data.persons, response.data.paginate));
        }

        const persons = setSelectItemLabels(response.data.persons, "id", "nickName");
        dispatch(setPersons(persons, personType));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiPersonsList =
  (token, personType = "all", cb) =>
  (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
      .get(`/persons/list/active?personType=${personType}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const persons = setSelectItemLabels(response.data.persons, "id", "nickName");
        dispatch(setPersons(persons, personType));
        dispatch(appSetLoading(false));
        if (cb) cb(persons);
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiDeletePersons = (selectedIds, token, tab, callback) => (dispatch, getState) => {
  const personIds = selectedIds;
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  axios
    .delete(`/persons/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { personIds ,personType:tab.key},
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddPersons = (forms, token, navigate, modalProps) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  dispatch(setAction("save"));
  apiAddPerson(dispatch, forms, token, 0, navigate, modalProps);
};

export const apiAddPerson = (dispatch, forms, token, index, navigate, modalProps, errorIndex = null) => {
  const form = forms[index];

  const nextApi = (res) => {
    if (index + 1 < forms.length) {
      apiAddPerson(dispatch, forms, token, index + 1, navigate, modalProps, errorIndex);
    } else {
      dispatch(appSetSendingRequest(false));
      if (errorIndex !== null) {
        dispatch(setAction("filling"));
        dispatch(apiSetAlert(forms[errorIndex].errors, "error"));
        dispatch(setIndex(forms[errorIndex].index));
      } else {
        dispatch(apiSetAlert("لیست اشخاص با موفقیت ثبت شد", "success", !!modalProps));
        if (modalProps) {
          dispatch(appCloseModal());
          dispatch(resetForm());
          if (res) {
            modalProps.onFinish(token, res);
          } else {
            dispatch(modalProps.onFinish(token));
          }
        } else {
          const type = forms[forms.length - 1].others.formType;
          navigate("/persons", {
            state: { type },
          });
        }
      }
    }
  };

  if (form.status !== "saved") {
    dispatch(setIndex(form.index));
    dispatch(updateFormStatus("saving"));

    const newFormData = setFormData(form);
    axios
      .post("/persons", newFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        dispatch(updateFormStatus("saved"));
        nextApi(response.data?.person);
      })
      .catch((error) => {
        errorIndex = index;
        dispatch(updateFormStatus("error", error?.response?.data?.message));
        nextApi();
      });
  } else {
    nextApi();
  }
};

export const apiUpdatePerson = (personId, form, token, navigate) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  const formData = setFormData(form);
  axios
    .put(`persons/${personId}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/persons", {
        state: { type: form.others.formType },
      });
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddPersonsExcel = (forms, token, callback) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  apiAddPersonExcel(dispatch, forms, token, 0, callback);
};

export const apiAddPersonExcel = (dispatch, forms, token, index, callback) => {
  const form = forms[index];

  const nextApi = () => {
    if (index + 1 < forms.length) {
      apiAddPersonExcel(dispatch, forms, token, index + 1, callback);
    } else {
      dispatch(appSetSendingRequest(false));
      // dispatch(apiSetAlert("لیست اشخاص با موفقیت ثبت شد", "success"));
      callback(forms);
    }
  };

  if (form && form.status !== "saved") {
    form.status = "saving";

    const formData = setFormData(form);
    axios
      .post("/persons", formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        form.status = "saved";
        nextApi();
      })
      .catch((error) => {
        form.status = "error";
        form.error = error.response.data.message;
        nextApi();
      });
  } else {
    nextApi();
  }
};
